import { type Html, html, View } from 'rune-ts';
import klass from './ServiceSection.module.scss';
import { getResizedUrl } from '@services/MarppleShop/shared/util/image.ts';
import { font, staticFont } from '@services/MarppleShop/shared/typography';
import { map, pipe, toArray } from '@fxts/core';

export class ServiceSection extends View<{ is_mobile: boolean }> {
  override template(): Html {
    const { is_mobile } = this.data;

    const text = {
      title: is_mobile
        ? html.preventEscape(`기획, 디자인, 제작,<br /> 배송, 정산까지<br />
              모두 책임집니다`)
        : html.preventEscape(`기획, 디자인, 제작, 배송, 정산까지<br />
              모두 책임집니다`),
      desc: '상상만 했던 굿즈, 마플샵에서는 현실이 됩니다',
    };
    const services = [
      {
        img_url:
          '//s3.marpple.co/files/u_29089/2025/11/original/0a17078b3932418960048be0d0984aed6f7bd91c3.webp',
        title: '기획 ∙ 디자인',
        desc: html.preventEscape(`원하는 굿즈가 현실이 되도록 <br />기획부터 디자인까지 마플샵이 책임집니다`),
        background_class: klass.red,
      },
      {
        img_url:
          '//s3.marpple.co/files/u_29089/2025/11/original/214c5a6e9177f8e314141837fff1bde9f304b4d94.webp',
        title: '제작 ∙ 배송',
        desc: html.preventEscape(
          `제작, 주문 관리, 배송 등 고객님께<br/>굿즈가 전달되기까지의 전 과정을 관리해 드려요`,
        ),
        background_class: klass.green,
      },
      {
        img_url:
          '//s3.marpple.co/files/u_29089/2025/11/original/770e059db5db8bacbe1781c380cd2a522d7fcc182.webp',
        title: 'CS ∙ 운영',
        desc: html.preventEscape(`고객 문의 대응부터 운영 관리까지<br/>판매 이후의 모든 과정을 함께합니다`),
        background_class: klass.blue,
      },
      {
        img_url:
          '//s3.marpple.co/files/u_29089/2025/11/original/20ba473676a255b19105f4f7afda6e09f5cf3a921.webp',
        title: '판매 정산',
        desc: html.preventEscape(`얼마나 팔렸는지 한눈에 확인받고<br/> 손쉽게 정산할 수 있어요`),
        background_class: klass.brown,
      },
    ];
    return html`
      <section class="${klass.container}">
        <div class="${klass.title_wrapper}">
          <div class="${klass.title}">
            <div class="${staticFont('bebas_20_bold')}">CHAPTER 3.</div>
            <div class="${font('48_bold', '28_bold')}">${text.title}</div>
          </div>
          <div class="${font('20_medium', '14_medium')}">${text.desc}</div>
        </div>
        <div class="${klass.service_wrapper}">
          ${pipe(
            services,
            map(
              ({ img_url, title, desc, background_class }) =>
                html`<div class="${klass.service}">
                  <div class="${klass.image_wrapper} ${background_class}">
                    <img
                      src="${getResizedUrl({
                        url: img_url,
                        width: 468 * 2,
                        quality: 85,
                        format: 'webp',
                      })}"
                      class="${klass.main_img}"
                      alt="서비스 종류 이미지"
                    />
                  </div>
                  <div class="${klass.desc_wrapper}">
                    <div class="${font('24_bold', '20_bold')}">${title}</div>
                    <div class="${klass.desc} ${font('20_medium', '14_medium')}">${desc}</div>
                  </div>
                </div>`,
            ),
            toArray,
          )}
        </div>
      </section>
    `;
  }
}
